/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable max-classes-per-file */
import { Modal, ModalController } from '~/scripts/services/modal/modal';
import fullWorkflowPage from '~/pages/workflow/workflow.html';
import WorkflowController from '~/pages/workflow/workflow.controller';

class Controller extends ModalController {
	/**
	 * @param {any} options
	 * @param {any} options
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('angular').auto.IInjectorService} $injector
	 */

	/* @ngInject */
	constructor(options, $uibModalInstance, $injector) {
		super(options, $uibModalInstance, $injector);

		this.onClick = options.onClick;
		this.onCancel = options.onCancel;

		this.wf = options.wf;
		this.actionKid = options.actionKid;
		this.affectKid = options.affectKid;
		this.kid = options.kid;
		this.options = options.options;
	}

	async create() {
		this.actions.close('aaa');
	}
}

class WFAffectSimpleModal extends Modal {
	/**
	 *
	 * @param {any} controllerData
	 * @returns {Promise<any>} Promise return
	 */
	open(controllerData) {
		return super.open({
			template:       `
<wf-form-actions
	options="$ctrl.options"
	on-click="$ctrl.onClick(controller)"
	on-cancel="$ctrl.onCancel(controller)"
	wf="$ctrl.wf"
	action-kid="$ctrl.actionKid"
	affect-kid="$ctrl.affectKid"
	kid="$ctrl.kid"
></wf-form-actions>
			`,
			controller:     Controller,
			controllerAs:   '$ctrl',
			windowTopClass: 'wf-affect-simple-modal',
		}, controllerData);
	}
}

class WFAffectFullModal extends Modal {
	/**
	 *
	 * @param {any} controllerData
	 * @param {import('@knitiv/api-client-javascript').KNode} affectKid
	 * @returns {Promise<any>} Promise return
	 */
	open(controllerData, affectKid) {
		return super.open({
			template:       fullWorkflowPage,
			controller:     WorkflowController,
			controllerAs:   '$ctrl',
			size:           'full',
			windowTopClass: 'wf-affect-full-modal',
			resolve: {
				// `Modal.open()` étale dialogOptions par-dessus son propre `resolve` :
				// déclarer `resolve` ici écrase le sien, d'où `options` repris à la main.
				options:   () => controllerData,
				affectKid: () => affectKid,
			},
		}, controllerData);
	}
}

export { WFAffectSimpleModal, WFAffectFullModal };

